import React, { useEffect, useState } from "react";
import { ANDROID_URL, IOS_URL } from "../lib/appLinks";
import AppBadges from "../components/AppBadges";
import logo from "../assets/logo.png";

export default function AppRedirect() {
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    if (/android/i.test(ua)) {
      setRedirected(true);
      window.location.replace(ANDROID_URL);
    } else if (/iPad|iPhone|iPod/i.test(ua)) {
      setRedirected(true);
      window.location.replace(IOS_URL);
    }
  }, []);

  return (
    <div className="min-h-screen bg-navy relative overflow-hidden flex items-center justify-center px-5" data-testid="app-redirect-page">
      <div className="grain-overlay" />
      <div className="relative text-center max-w-md">
        <div className="inline-block bg-white rounded-2xl p-3 shadow-lg ring-1 ring-gold/30">
          <img src={logo} alt="SVS College of Nursing" className="h-24 w-auto object-contain" />
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl text-sand mt-8">Download the SVS College app</h1>
        <p className="text-sand/70 mt-4">
          {redirected
            ? "Redirecting you to the store…"
            : "Choose your platform below to install the app."}
        </p>
        <div className="mt-8 flex justify-center">
          <AppBadges />
        </div>
      </div>
    </div>
  );
}
